import './Modal.css';

const ModalHeader = () => {
  return (
    <div className="modal-header">
      <img src="https://i.pinimg.com/originals/1f/b3/76/1fb3764fb0a25c84d97c707b5585ee6d.jpg" alt="" />
      <span className='fw-bold'>Melissa</span>
    </div>
  )
}

export default ModalHeader;